import React from 'react';
import MatchesTodayMatch from './MatchesTodayMatch';

export default function MatchesTodayTime({ matchTime }) {
  return (
    <>
      <div className="day today">
        <h6>{matchTime.time}</h6>
      </div>
      {matchTime.matches.map((match) => {
        return <MatchesTodayMatch match={match} />;
      })}
    </>
  );
}
